import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppRouters from "routes";
import { AxiosInterceptor } from "api/setupAxios";
import { store } from "./store";

function App() {
  return (
    <BrowserRouter>
      <AxiosInterceptor>
        <Provider store={store}>
          <AppRouters />
        </Provider>
      </AxiosInterceptor>

      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
